import { en } from './locales/en'
import { hu } from './locales/hu'
import { de } from './locales/de'
import { fr } from './locales/fr'
import { it } from './locales/it'
import { es } from './locales/es'
import { pl } from './locales/pl'
import { ro } from './locales/ro'

export const translations = {
  en,
  hu,
  de,
  fr,
  it,
  es,
  pl,
  ro
}

export type TranslationKey = keyof typeof translations.en
export type Language = keyof typeof translations
